var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { LevelQuestions } from './modules/LevelQuestions';
import { cachedSet } from '../../../utils/mobx/decorators/customComputed';
export class Level {
    type = 'level';
    parent;
    name = '';
    constructor(parent, name) {
        makeObservable(this);
        this.parent = parent;
        this.name = name;
    }
    levelQuestions = new LevelQuestions(this);
    get topic() {
        return this.parent;
    }
    get app() {
        return this.topic.context.app;
    }
    get microQuestions() {
        return this.topic.topicMicroQuestions.microQuestions.filter(micro => micro.subtopicName === this.name);
    }
    get count() {
        return this.microQuestions.length;
    }
    get miniQuestionsOfThisTag() {
        return this.topic.topicMiniQuestions.miniQuestions.filter(mini => mini.micro.levelTag === this.name);
    }
    get numberOfQuestionsOfThisTag() {
        return this.miniQuestionsOfThisTag.length;
    }
}
__decorate([
    cachedSet
], Level.prototype, "miniQuestionsOfThisTag", null);
__decorate([
    computed
], Level.prototype, "numberOfQuestionsOfThisTag", null);
